<template>
  <div class="login">
    <div class="login__card">
      <div class="login__brand">
        <div class="login__logo">E</div>
        <div>
          <div class="login__wordmark">Ekspertiza</div>
          <div class="login__sub">Prijava na sistem</div>
        </div>
      </div>

      <el-form
        class="login__form"
        label-position="top"
        :model="model"
        :rules="rules"
        ref="form"
        @submit.native.prevent="login"
      >
        <div v-if="error" class="login__error">
          <i class="el-icon-warning-outline"></i>
          <span>{{ error }}</span>
        </div>

        <el-form-item prop="username" label="Email">
          <el-input
            v-model="model.username"
            type="email"
            placeholder="ime@ekspertiza.ba"
            autocomplete="username"
            @input="error = ''"
          ></el-input>
        </el-form-item>

        <el-form-item prop="password" label="Lozinka">
          <el-input
            v-model="model.password"
            placeholder="••••••••"
            type="password"
            autocomplete="current-password"
            show-password
            @input="error = ''"
          ></el-input>
        </el-form-item>

        <el-button
          :loading="loading"
          class="login__button"
          type="primary"
          native-type="submit"
        >Prijavi se</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Auth",
  data() {
    return {
      model: {
        username: "",
        password: "",
      },
      loading: false,
      error: "",
      rules: {
        username: [
          { required: true, message: "Email je obavezan", trigger: "blur" },
          { type: "email", message: "Unesite ispravan email", trigger: "blur" },
        ],
        password: [{ required: true, message: "Lozinka je obavezna", trigger: "blur" }],
      },
    };
  },
  methods: {
    async login() {
      let valid = await this.$refs.form.validate().catch(() => false);
      if (!valid) {
        return;
      }
      this.loading = true;
      this.error = "";
      let email = this.model.username;
      let password = this.model.password;
      this.$store
        .dispatch("auth/login", { email, password })
        .then(() => {
          this.$router.push("/");
        })
        .catch((err) => {
          // A wrong password used to fail silently and just re-render the
          // form, which reads as "nothing happened".
          const status = err && err.response && err.response.status;
          this.error =
            status === 401
              ? "Pogrešan email ili lozinka."
              : "Prijava trenutno nije moguća. Pokušajte ponovo.";
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background: var(--navy);
}

.login__card {
  width: 100%;
  max-width: 380px;
  background: var(--surface);
  border-radius: 10px;
  padding: 30px 32px 32px 32px;
  box-shadow: 0 18px 40px rgba(6, 20, 35, 0.32);
  box-sizing: border-box;
}

.login__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 26px;
}

.login__logo {
  width: 40px;
  height: 40px;
  border-radius: var(--r-lg);
  background: var(--brand);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-title);
  font-weight: 700;
  flex-shrink: 0;
}

.login__wordmark {
  font-size: 19px;
  font-weight: 700;
  color: var(--ink);
  line-height: 1.2;
}

.login__sub {
  font-size: var(--fs-md);
  color: var(--ink-3);
  margin-top: 2px;
}

.login__error {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--danger-tint);
  border: 1px solid var(--danger-line);
  color: var(--danger);
  border-radius: var(--r-md);
  padding: 9px 12px;
  font-size: var(--fs-md);
  margin-bottom: 16px;
}

.login__button {
  width: 100%;
  margin-top: 6px;
}

.login__form ::v-deep .el-form-item__label {
  font-size: var(--fs-sm);
  color: var(--ink-2);
  padding-bottom: 2px;
  line-height: 1.6;
}

.login__form ::v-deep .el-form-item {
  margin-bottom: 16px;
}
</style>
